import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRepository } from '../../../../shared/infrastructure/api.repository';
import {
  CommunicationListPagedRequest,
  CommunicationListPagedResponse,
  CommunicationRepositoryPort,
} from '../../domain/repositories/communication.repository.port';
import { CommunicationEvents } from '../../domain/entities/communication-event.entity';
import { LoadManualCommunicationDto } from '../../application/dtos/load-manual-communication.dto';
import { CommunicationMapper, CommunicationPagedApi, CommunicationEventsApi } from '../mappers/communication.mapper';

@Injectable({ providedIn: 'root' })
export class CommunicationRepository extends ApiRepository implements CommunicationRepositoryPort {
  private readonly baseUrl = '/entityCommunications';

  getEntityCommunications(request: CommunicationListPagedRequest): Observable<CommunicationListPagedResponse> {
    return this.post<CommunicationPagedApi, CommunicationListPagedRequest>(
      `${this.baseUrl}/GetListPaged`,
      request,
    ).pipe(
      map((response) => ({
        ...response,
        items: response.items.map(CommunicationMapper.toDomain),
      })),
    );
  }

  getCommunicationEvents(communicationId: string): Observable<CommunicationEvents> {
    return this.get<CommunicationEventsApi>(`${this.baseUrl}/${communicationId}/Events`).pipe(
      map(CommunicationMapper.toEventsDomain),
    );
  }

  downloadEventDocument(communicationId: string, eventId: string, documentId: string): Observable<Blob> {
    return this.http.get(
      `${this.baseApiUrl}${this.baseUrl}/${communicationId}/Events/${eventId}/Documents/${documentId}`,
      { responseType: 'blob' },
    );
  }

  markReviewed(communicationId: string, comments: string): Observable<void> {
    return this.post<void, { comments: string }>(
      `${this.baseUrl}/${communicationId}/Review/Reviewed`,
      { comments },
    );
  }

  relaunch(communicationId: string): Observable<void> {
    return this.post<void, null>(`${this.baseUrl}/${communicationId}/Relaunch`, null);
  }

  loadManual(dto: LoadManualCommunicationDto): Observable<void> {
    const formData = new FormData();
    formData.append('contractId', dto.contractId.toString());
    formData.append('isMigrated', dto.isMigrated.toString());
    dto.files.forEach((f, i) => {
      formData.append(`files[${i}].formFile`, f.file);
      if (f.action != null) formData.append(`files[${i}].action`, f.action.toString());
      formData.append(`files[${i}].category`, f.category.toString());
    });
    return this.http.post<void>(`${this.baseApiUrl}${this.baseUrl}/LoadManual`, formData);
  }
}
